import Main from '@/main.vue';

/**
 * iView-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  sort: number 父级添加 确定路由显示的顺序
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */
export default [
  {
    path: '/',
    name: 'home',
    component: Main,
    meta: {
      title: '欢迎页',
      icon: 'md-home',
      hideInMenu: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../../views/login/login.vue'),
    meta: {
      title: 'Login',
      icon: 'md-home',
      hideInMenu: true
    }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../../views/register/register.vue'),
    meta: {
      title: '管理员申请',
      icon: 'md-home',
      hideInMenu: true
    }
  },
  { path: '/promptManage',
    name: 'promptManage',
    component: Main,
    sort: 2,
    meta: { title: '提示管理', icon: 'ios-list-box-outline' },
    children: [
      { path: 'promptList',
        name: 'promptList',
        meta: { title: '提示词列表', icon: 'md-images' },
        component: () => import('@views/admin/prompt/promptList.vue')
      }
    ]
  },
  {
    path: '/clientUserManage',
    name: 'clientUserManage',
    component: Main,
    sort: 2,
    meta: { title: '用户管理', icon: 'ios-list-box-outline' },
    children: [
      {
        path: 'clientUserList',
        name: 'clientUserList',
        meta: { title: '用户列表', icon: 'ios-contacts-outline' },
        component: () => import('@views/admin/clientUserList/clientUserList.vue')
      }
    ]
  },
  {
    path: '/userManage',
    name: 'userManage',
    component: Main,
    sort: 2,
    meta: { title: '管理员', icon: 'ios-list-box-outline' },
    children: [
      {
        path: 'userList',
        name: 'userList',
        meta: { title: '用户列表', icon: 'ios-contacts-outline' },
        component: () => import('@views/admin/userList/userList.vue')
      }
    ]
  },
  {
    path: '/knowledgeManage',
    name: 'knowledgeManage',
    component: Main,
    sort: 2,
    meta: { title: '知识库管理', icon: 'ios-list-box-outline' },
    children: [
      {
        path: 'knowledgeList',
        name: 'knowledgeList',
        meta: { title: '知识库列表', icon: 'ios-contacts-outline' },
        component: () => import('@views/admin/knowledgeList/knowledgeList.vue')
      }
    ]
  },
  {
    path: '/loginLogManage',
    name: 'loginLogManage',
    component: Main,
    sort: 2,
    meta: { title: '登录日志管理', icon: 'ios-list-box-outline' },
    children: [
      {
        path: 'loginLogList',
        name: 'loginLogList',
        meta: { title: '登录日志列表', icon: 'ios-contacts-outline' },
        component: () => import('@views/admin/loginLogList/loginLogList.vue')
      }
    ]
  }
];
